import { Typography } from '@cp/ds/src/components/typography';

export const EmptyCatalog = () => (
  <Typography component="div" sx={{ width: 1, pt: 4, pb: 10, textAlign: 'center', color: 'gray' }} variant="body">
    Ничего не найдено
  </Typography>
);
